import React from "react";

import "./SubHeader.scss";
import GridIcon from "../../assets/icons/grid.svg";
import ListIcon from "../../assets/icons/list.svg";
import Close from "../../assets/icons/close.svg";
import SelectAllCheckBox from "../UI/CheckBox/SelectAllCheckBox/SelectAllCheckBox";
import Filter from "../Filter/Filter";
import DownloadDropDown from "../UI/DownloadDropDown/DownloadDropDown";
import DropDown from "../UI/DropDown/DropDown";
import DateRange from "../UI/DateRange/DateRange";
import SavedViewsContainer from "../SavedViewsContainer/SavedViewsContainer";
import InstructionBulb from "../InstructionBulb/InstructionBulb";
import { gql, useMutation } from "@apollo/client";
import { notify } from "../Notify/Notify";

const APPROVE_DOCUMENTS = gql`
  mutation ApproveDocuments($userApprovalIds: [String!]!, $status: String!) {
    approveDocuments(userApprovalIds: $userApprovalIds, status: $status) {
      success
    }
  }
`;

const FolderRoute = ({
  searchValue,
  setSearchValue,
  searchPlaceholder,
  handleSavedViewsApply,
  isApprovalRequired = false,
  loadData,
  ...props
}) => {
  const [isGridView, setIsGridView] = React.useState(false);
  const [approveDocuments, { loading: isApproveDocuments }] =
    useMutation(APPROVE_DOCUMENTS);

  const getInstructionString = () => {
    let instruction = "";
    if (props.isFoldersView) {
      // Root folder
      const currentFolder = props.rootFolders.find(
        (folder) => folder.id === props.match.params.folderId
      );
      if (currentFolder) {
        instruction = currentFolder.instruction;
      }
    } else {
      // Sub folder
      if (props.subFolders[props.match.params.folderId]) {
        const currentFolder = props.subFolders[
          props.match.params.folderId
        ].find((subFolder) => subFolder.id === props.match.params.subId);
        if (currentFolder) {
          instruction = currentFolder.instruction;
        }
      }
    }
    return instruction;
  };

  const getContentRole = (userRoleId) => {
    const folder =
      props.subFolders[props.match.params.folderId] &&
      props.subFolders[props.match.params.folderId].find(
        (subFolder) => subFolder.id === props.match.params.subId
      );
    if (userRoleId === 1 || userRoleId === 2) {
      return true;
    } else if (folder) {
      const createUserId = folder.createdBy.id;
      const logUserId = props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = true;
      } else {
        const sharedUsers = folder.sharedFolder.map((sharedItem) => {
          return {
            id: sharedItem.user.id,
            role: sharedItem.userRole.name,
          };
        });
        const getAccess = sharedUsers.find(
          (sharedUser) =>
            sharedUser.id === logUserId &&
            (sharedUser.role === "Owner" ||
              sharedUser.role === "Collaborator" ||
              sharedUser.role === "Viewer")
        );
        returnedVal = getAccess ? true : false;
      }
      return returnedVal;
    }
  };

  const checkRole = (type) => {
    if (props.isFoldersView) {
      if (props.userRoleId === 1 || props.userRoleId === 2) {
        return true;
      } else {
        const filterSubFolders = props.subFolders.filter(
          (subFolder) => props.checkedItems[subFolder.id]
        );

        const check =
          type === "Owner"
            ? filterSubFolders.filter((sub) => {
                const getLoginUser = sub.sharedFolder.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter((user) => user.userRole.name === "Owner")
                    .length === getLoginUser.length
                );
              }).length === filterSubFolders.length
            : filterSubFolders.filter((sub) => {
                const getLoginUser = sub.sharedFolder.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter(
                    (user) =>
                      user.userRole.name === "Owner" ||
                      user.userRole.name === "Collaborator"
                  ).length === getLoginUser.length
                );
              }).length === filterSubFolders.length;
        return check;
      }
    } else if (props.isDocumentView) {
      if (props.userRoleId === 1 || props.userRoleId === 2) {
        return true;
      } else {
        const filterDocuments = props.documents.filter(
          (document) => props.checkedItems[document.id]
        );

        const check =
          type === "Owner"
            ? filterDocuments.filter((sub) => {
                const getLoginUser = sub.sharedDocument.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter((user) => user.userRole.name === "Owner")
                    .length === getLoginUser.length
                );
              }).length === filterDocuments.length
            : filterDocuments.filter((sub) => {
                const getLoginUser = sub.sharedDocument.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter(
                    (user) =>
                      user.userRole.name === "Owner" ||
                      user.userRole.name === "Collaborator"
                  ).length === getLoginUser.length
                );
              }).length === filterDocuments.length;
        return check;
      }
    }
  };
  const getApproveButtonStatusAndApprovalIds = () => {
    const {
      checkedItems = {},
      documents = [],
      currentUserInfo: { id: currentUserId = "" } = {},
    } = props;
    const selectedId = [];
    for (const key in checkedItems) {
      if (Object.hasOwnProperty.call(checkedItems, key)) {
        const isChecked = checkedItems[key];
        if (isChecked) {
          selectedId.push(key);
        }
      }
    }
    if (selectedId.length === 0) {
      return [false, []];
    }
    let flags = [];
    const userApprovals = [];
    const requiresApprovalFlags = [];
    const documentInDraftOrReceivedFlags = [];
    selectedId.forEach((id) => {
      const currentDocs = documents.find((document) => document.id === id);
      if (!currentDocs) {
        return;
      }
      const { approvalLevels } = currentDocs;
      if (approvalLevels.length === 0) {
        return;
      }
      if (["Received", "Draft"].includes(currentDocs?.status?.name)) {
        documentInDraftOrReceivedFlags.push(true);
      } else {
        documentInDraftOrReceivedFlags.push(false);
      }
      const isRequiresApproval = requiresApproval(
        approvalLevels,
        currentUserId
      );
      requiresApprovalFlags.push(isRequiresApproval);
      let flag = false;
      approvalLevels.forEach((approvalLevel) => {
        approvalLevel.userApproval.forEach((userApproval) => {
          const userId = userApproval.user.id;
          if (currentUserId === userId) {
            userApprovals.push(userApproval.id);
            flag = true;
          }
        });
      });
      flags.push(flag);
    });

    if (documentInDraftOrReceivedFlags.some((state) => state)) {
      const error = generateFileStateMessage(documentInDraftOrReceivedFlags);
      return [flags.every(Boolean), userApprovals, error];
    }
    if (
      requiresApprovalFlags.some(
        (requiresApprovalFlags) => !requiresApprovalFlags
      )
    ) {
      const error = generateApprovalMessage(requiresApprovalFlags);
      return [flags.every(Boolean), userApprovals, error];
    }
    return [flags.every(Boolean), userApprovals];
  };
  const onSearch = (e) => {
    const val = e.target.value;
    setSearchValue(val);
  };
  const getSearchBox = () => (
    <div className="search-box mr-2">
      <input
        type="text"
        maxLength="50"
        placeholder={searchPlaceholder}
        className="search-placeholder set-width"
        value={searchValue}
        onChange={onSearch}
      />
    </div>
  );

  const handleListGridToggle = () => {
    if (isGridView) {
      props.displayListHandler();
    } else {
      props.displayGridtHandler();
    }
    setIsGridView((isGridView) => !isGridView);
  };
  const [shouldShowApproveButton = false, approvalIds = []] =
    getApproveButtonStatusAndApprovalIds();

  return (
    <div className="col mt-6 mb-8 folder-router">
      {props.isArchivedView ? (
        <div className="d-md-flex">
          <div className="ml-auto pr-2 pt-1">
            {props.totalChecked() && props.totalDocuments > 0 ? (
              <DropDown
                restoreHandler={props.restoreAllHandler}
                deleteHandler={props.deleteAllHandler}
                isArchivedDropdown={props.isArchivedView}
              />
            ) : null}
          </div>
          <DateRange setDateFilter={props.setDateFilter} />

          {(props.isDocumentArchive || props.isSubFolderArchive) && (
            <Filter
              isArchivedView={props.isArchivedView}
              isSubFolderArchive={props.isSubFolderArchive}
              isDocumentArchive={props.isDocumentArchive}
              categories={props.categories}
              filterApplyHandler={props.filterApplyHandler}
              documents={props.documents}
            />
          )}
        </div>
      ) : null}
      {props.isFoldersView ? (
        <div className="d-md-flex align-items-center">
          {getSearchBox()}
          <Filter
            isFoldersView={props.isFoldersView}
            subfolders={props.subFolders}
            filterApplyHandler={props.filterApplyHandler}
          />
          <InstructionBulb title={getInstructionString()} />

          {props.displayListView ? null : (
            <div className="d-md-flex ml-3 mr-3 align-items-center">
              <SelectAllCheckBox
                checked={props.checked}
                selectAllHandler={props.selectAllHandler}
              />
              <div style={{ whiteSpace: "nowrap" }}>Select all</div>
            </div>
          )}

          {props.totalChecked() > 0 ? (
            <>
              <div className="btn btn-tertiary custom-btn ml-3">
                <div style={{ whiteSpace: "nowrap" }}>
                  {props.totalChecked()} selected
                </div>
                <img
                  className="ml-1"
                  src={Close}
                  width="12"
                  height="12"
                  alt="close"
                  onClick={props.unselectAllHandler}
                />
              </div>
              {checkRole("Collaborator") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleShare}
                >
                  Share
                </div>
              ) : null}
              {checkRole("Owner") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleArchive}
                >
                  Archive
                </div>
              ) : null}
            </>
          ) : null}

          <div
            className="list-action-button ml-auto"
            onClick={handleListGridToggle}
          >
            <img
              src={isGridView ? ListIcon : GridIcon}
              alt="Grid List button"
            />
          </div>
        </div>
      ) : null}
      {props.isDocumentView ? (
        <div className="d-md-flex align-items-center">
          {getSearchBox()}
          <Filter
            isDocumentView={props.isDocumentView}
            documents={props.documents}
            loadDocuments={props.loadDocuments}
            filterApplyHandler={props.filterApplyHandler}
          />
          <InstructionBulb title={getInstructionString()} />
          {props.displayListView ? null : (
            <div className="d-md-flex mx-3 align-items-center">
              <SelectAllCheckBox
                checked={props.checked}
                selectAllHandler={props.selectAllHandler}
              />
              <div style={{ whiteSpace: "nowrap" }}>Select all</div>
            </div>
          )}
          {props.totalChecked() > 0 ? (
            <>
              <div className="btn btn-tertiary text-auto custom-btn ml-3">
                {props.totalChecked()} selected
                <img
                  className="ml-1"
                  src={Close}
                  width="12"
                  height="12"
                  alt="close"
                  onClick={props.unselectAllHandler}
                />
              </div>
              {checkRole("Owner") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.showMoveFileModal}
                >
                  Move
                </div>
              ) : null}
              {checkRole("Collaborator") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleShare}
                >
                  Share
                </div>
              ) : null}
              {checkRole("Owner") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleArchive}
                >
                  Archive
                </div>
              ) : null}
              {isApprovalRequired && shouldShowApproveButton ? (
                <button
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={async () => {
                    const [, , errorMessage] =
                      getApproveButtonStatusAndApprovalIds();
                    if (typeof errorMessage === "string" && errorMessage) {
                      notify("Error", errorMessage, "error");
                      return;
                    }
                    const status = "APPROVED";
                    try {
                      await approveDocuments({
                        variables: { userApprovalIds: approvalIds, status },
                      });
                      notify(
                        "Success",
                        "Document(s) are successfully approved.",
                        "success"
                      );
                      loadData();
                    } catch (error) {
                      notify("Error", "Something went wrong.", "error");
                      console.log(error);
                    }
                  }}
                  disabled={isApproveDocuments}
                >
                  Approve Selected
                </button>
              ) : null}
            </>
          ) : null}
          <div className="ml-auto d-flex pl-3">
            {!props.isSearchDocuments ? (
              <>
                <SavedViewsContainer
                  {...{
                    handleSavedViewsApply,
                    selectedColumns: props.selectedColumns,
                    folderId: props.match.params.folderId,
                  }}
                />

                {getContentRole(props.userRoleId) ? (
                  <DownloadDropDown {...props} />
                ) : null}
              </>
            ) : null}

            <div
              className="list-action-button ml-auto"
              onClick={handleListGridToggle}
            >
              <img
                src={isGridView ? ListIcon : GridIcon}
                alt="Grid List button"
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FolderRoute;

// Helper functions

function requiresApproval(approvalLevels, currentUser) {
  for (const level of approvalLevels) {
    for (const userApproval of level.userApproval) {
      if (
        userApproval.user.id === currentUser &&
        userApproval.status === "PENDING"
      ) {
        return true; // Approval needed
      }
    }
  }
  return false; // No approval needed
}

function generateApprovalMessage(approvalStatus) {
  const allApproved = approvalStatus.every((status) => status === false);
  const len = approvalStatus.length;

  if (allApproved && len === 1) {
    return "The document has already been approved.";
  } else if (allApproved && len > 1) {
    return "The documents have already been approved.";
  } else {
    return "Some of the documents have already been approved.";
  }
}

function generateFileStateMessage(filesStatus) {
  const allReceivedOrDrafts = filesStatus.every((status) => status === true);
  const len = filesStatus.length;
  if (allReceivedOrDrafts && len === 1) {
    return "The document is in received or draft state.";
  } else if (allReceivedOrDrafts && len > 1) {
    return "The documents are in received or draft state.";
  } else {
    return "Some of the documents are in received or draft state.";
  }
}
